import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import Services from "./components/Services/Services";
import Home from "./components/Home/Home";
import About from "./components/About/About";
import Contact from "./components/Contact/Contact";
import ServiceDetails from "./components/Services/ServiceDetails";
import Products from "./components/Products/Products";
import Careers from "./components/Careers/Careers";
import JobOpportunities from "./components/JobOpportunities/JobOpportunities";

const appRouter = createBrowserRouter([
  {
    path: "/",
    element: <App />,
    children: [
      {
        path: "/",
        element: <Home />,
      },
      {
        path: "/services",
        element: <Services />,
      },
      {
        path: "/about",
        element: <About />,
      },
      {
        path: "/contact-us",
        element: <Contact />,
      },
      {
        path: "/services/:service",
        element: <ServiceDetails />,
      },
      {
        path: "/products",
        element: <Products />,
      },
      {
        path: "/careers",
        element: <Careers />,
      },
      {
        path: "/job-opportunities",
        element: <JobOpportunities />,
      },
    ],
  },
]);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <RouterProvider router={appRouter}>
    <App />
  </RouterProvider>
);
